const CommonBorder = ({ notMargin, dotted }) => {
  return (
    <div
      className={`border-b-[0.5px] border-input-border-color ${
        notMargin || "my-[10px]"
      } ${dotted && "border-dotted !border-b-2"}`}
    ></div>
  );
};

export default CommonBorder;
